import gql from 'graphql-tag';

const BAGGING_FINISH = gql`
    mutation baggingFinish($input: BaggingInput) {
        finish(input: $input) {
            internalCode
        }
    }
`;

export default BAGGING_FINISH;
